import {TranslationObject} from '@colonist/i18n'
import {uiGameManager} from '../../../shared/scripts/EntryShared'
import {PIXI} from '@colonist/pixi'
import {ToolTipText} from 'code/client/web/scripts/ui_game/ui_game_tooltip/UIWGameToolTipController'

export class SpriteView extends PIXI.Sprite {
    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, texture: PIXI.Texture, padding: number = 0) {
        super()
        this.x = x + padding
        this.y = y + padding
        this.width = w - padding * 2
        this.height = h - padding * 2
        this.texture = texture
        container.addChild(this)
    }

    updateTexture(texture: PIXI.Texture) {
        if(this.texture == texture) return
        this.texture = texture
    }

    centerXInParent() {
        if(this.parent == undefined) return
        this.x = this.parent.width / 2 - this.width / 2
    }

    centerYInParent() {
        if(this.parent == undefined) return
        this.y = this.parent.height / 2 - this.height / 2
    }

    rotate(degrees: number) {
        if(this.anchor.x !== 0.5) {
            this.anchor.set(0.5)
            this.x += this.width / 2
            this.y += this.height / 2
        }
        this.rotation = degrees * Math.PI / 180
    }

    setClickAction(action: (event) => void) {
        if(this.cursor != 'pointer') this.cursor = 'pointer'
        if(!this.interactive) this.interactive = true
        this.on('click', (event) => {
            action(event)
        })
        this.on('tap', (event) => {
            action(event)
        })
    }

    setRightClickAction(action: (event) => void) {
        if(this.cursor != 'pointer') this.cursor = 'pointer'
        if(!this.interactive) this.interactive = true
        this.on('rightclick', (event) => {
            action(event)
        })
    }

    removeClickAction() {
        if(this.cursor == 'pointer') this.cursor = 'auto'
        if(this.interactive) this.interactive = false
        this.removeAllListeners()
    }

    setHoverAction(pointerover: (event) => void, pointerout: (event) => void) {
        if(this.cursor != 'pointer') this.cursor = 'pointer'
        if(!this.interactive) this.interactive = true
        this.on('pointerover', (event) => {
            pointerover(event)
        })
        this.on('pointerout', (event) => {
            pointerout(event)
        })
    }

    setTip(title: TranslationObject, bodyParagraphs: TranslationObject[], toolTipText?: ToolTipText) {
        // Everything should be refactored to `toolTipText` but it was going to take too long to refactor 26 references
        if(toolTipText != undefined) {
            uiGameManager.toolTipController.createTip(toolTipText, this)
        } else {
            const tipText: ToolTipText = () => ({title: title, body: bodyParagraphs})
            uiGameManager.toolTipController.createTip(tipText, this)
        }
    }
}
